var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGlasses = function SvgGlasses(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M3 14v2a4 4 0 0 0 4 4h.412a3 3 0 0 0 3-3v-3m3.176 0v3a3 3 0 0 0 3 3H17a4 4 0 0 0 4-4v-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 14H3l2.872-9.476A1.088 1.088 0 0 1 8 4.839V5.2M10 14h11l-3.142-9.424a1.21 1.21 0 0 0-2.358.382V5.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlasses);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;